export default {
  settings: 'Impostazioni',
  storefront: 'Vetrina',
  media: 'Media',
  style: 'Stile',
  scripts: 'Script',
  no_google_place: {
    title: "L'azienda non è collegata a nessuna posizione Google",
    description: "Collega l'azienda a una posizione Google",
  },
};
